const excluded = ['ds_store'];

export function filterUpload(
  file: { name?: string } | { file: { name?: string } }
) {
  const name = 'file' in file ? file.file?.name : file?.name;
  const ext = name?.split('.').pop()?.toLowerCase();

  return ext ? !excluded.includes(ext) : true;
}
